// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"45019b38","95":"af1f6d21","973":"f78c8d07"}[chunkId] + ".chunk.js";
};